import { useClientContext } from 'context/ClientContext';
import { useListagemContext } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useCarrinhoContext } from 'pages/compra/carrinho/contexts';
import { useQueryConfiguracaoMinimo, useQueryTotalizador, useQueryTotalizadorDataEntrega } from 'pages/compra/carrinho/hooks';
import { brlDate } from 'util/format';

export function useCarrinhoBbar() {
    const { selectedPedidos, disabledActions, pedidos, isFinishAllPolling } = useCarrinhoContext();
    const { data: totalizador, isFetching: isFetchingTotalizador } = useQueryTotalizador();
    const { data: configMinimo, isFetching: isFetchingConfigMinimo } = useQueryConfiguracaoMinimo();
    const { tipoPedido } = useClientContext();
    const { getFilterValues } = useListagemContext();
    const { hasPermission } = usePermissionsContext();
    const { idLoja: lojas = [], idUsuario: funcionario } = getFilterValues();

    const hasMinimo = Boolean(configMinimo?.vlPesoTotalPedidoMinimo || configMinimo?.vlTotalPedidoMinimo);
    const hasSelection = selectedPedidos.length > 0;
    const dtEntregaSelecionado = selectedPedidos[0]?.grade?.dtEntrega;
    const hasPedidoNormal = selectedPedidos[0]?.configPedido.idTipoPedido !== 4; // 4 = Totalizador
    const hasPedidoFinalizando = pedidos?.some((p) => p.pedidoStatus.idPedidoStatus === 19); // 19 = Finalizando
    const hasPedidoFinalizandoSelection = selectedPedidos?.some((p) => p.pedidoStatus.idPedidoStatus === 19); // 19 = Finalizando

    const { data: totaisData, isFetching: isFetchingTotaisData } = useQueryTotalizadorDataEntrega(dtEntregaSelecionado, hasMinimo);

    const selectionVlTotal = hasSelection
        ? selectedPedidos.reduce(
              (acc, p) => (p.configPedido.idTipoPedido === 4 ? acc : acc + (p.vlTotal || 0)), // 4 = Totalizador
              totaisData?.vlTotal ?? 0,
          )
        : 0;

    const selectionVlPeso = hasSelection
        ? selectedPedidos.reduce(
              (acc, p) => (p.configPedido.idTipoPedido === 4 ? acc : acc + (p.vlPesoLiquidoTotal || 0)), // 4 = Totalizador
              totaisData?.vlPesoLiquidoTotal ?? 0,
          )
        : 0;

    const dtEntregaLabel = dtEntregaSelecionado != null ? brlDate(`${dtEntregaSelecionado}T00:00:00`) : undefined;

    const pePeso = configMinimo?.vlPesoTotalPedidoMinimo ? (selectionVlPeso / configMinimo.vlPesoTotalPedidoMinimo) * 100 : undefined;

    const peValor = configMinimo?.vlTotalPedidoMinimo ? (selectionVlTotal / configMinimo.vlTotalPedidoMinimo) * 100 : undefined;

    const withoutFuncionario = !funcionario && tipoPedido === 'funcionario' && hasPermission(['COMPRA_PEDIDO_FINALIZACAO_GERAL']);
    const withoutLoja = lojas.length !== 1 && tipoPedido === 'padrao';

    let tooltipTitle = '';

    if (!totalizador?.vlTotal) {
        tooltipTitle = 'Não há pedidos para finalizar.';
    } else if (withoutLoja) {
        tooltipTitle = 'Selecione apenas uma loja para finalizar todos os pedidos.';
    } else if (withoutFuncionario) {
        tooltipTitle = 'Selecione um funcionário para finalizar todos os pedidos.';
    } else if ((hasPedidoFinalizando && !hasSelection) || hasPedidoFinalizandoSelection) {
        tooltipTitle = 'Não é possivel finalizar pedidos já finalizando.';
    } else if (hasPedidoNormal) {
        if (configMinimo?.vlTotalPedidoMinimo && selectionVlTotal < configMinimo.vlTotalPedidoMinimo) {
            tooltipTitle = 'Valor mínimo não atingido.';
        } else if (configMinimo?.vlPesoTotalPedidoMinimo && selectionVlPeso < configMinimo.vlPesoTotalPedidoMinimo) {
            tooltipTitle = 'Peso mínimo não atingido.';
        }
    }

    const disableFinalizarAll = Boolean(disabledActions || tooltipTitle);

    return {
        disableFinalizarAll,
        tooltipTitle,
        totalizador,
        configMinimo,
        isFetching: isFetchingTotalizador || isFetchingConfigMinimo || isFetchingTotaisData || disabledActions || isFinishAllPolling,
        selectedPedidos,
        hasSelection,
        selectionVlTotal,
        selectionVlPeso,
        pePeso,
        peValor,
        dtEntregaLabel,
    };
}
